import { Link } from 'component/Link'
import { Space } from 'component/Space/Space'
import { Typo } from 'component/Typo/Typo'
import { observer } from 'mobx-react-lite'
import { store } from 'page/tryon/store/TryOnPageStore'
import css from './Footer.module.scss'

export const Footer = observer(() => {
  const { footer } = store.it
  const { powered, by, url } = footer

  return <Space className={css.footer} gap={4} height={32} center>
    <Typo size={8} secondary>
      {powered}
    </Typo>
    <Typo size={8}>
      {<Link href={url}>
        {by}
      </Link>}
    </Typo>
  </Space>
})
